import { userService } from '@/_services'
import Vue from 'vue'
const grants = JSON.parse(localStorage.getItem('grants')) || [];
const user = JSON.parse(localStorage.getItem('user'));
const initialState = user ? { status: { loggedIn: true }, user } : { status: {}, user: null };

export const authentication = {
  namespaced: true,
  state: {
    initialState: initialState,
    status: null,
    grants
  },
  actions: {
    login({ dispatch, commit }, { username, password }) {
      commit('loginRequest', { username });

      userService.login(username, password)
      .then(
        user => {
          commit('loginSuccess', user);
          router.push('/themes');
        },
        error => {
          commit('loginFailure', error);
          Vue.swal({
            title: "Ошибка",
            text: "Логин или пароль указаны не правильно."
          });
        }
      );
    },
    logout({ commit }) {
      userService.logout();
      commit('logout');
    }
  },
  mutations: {
    setStatus(state, status) {
      state.status = status
    },
    loginRequest(state, user) {
      state.status = { loggingIn: true };
      state.user = user;
    },
    loginSuccess(state, user) {
      state.status = { loggedIn: true };
      state.user = user;
    },
    loginFailure(state) {
      state.status = {};
      state.user = null;
    },
    logout(state) {
      state.status = {};
      state.user = null;
    }
  }
}